import {Component, OnInit} from '@angular/core';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, Router} from '@angular/router';

import {Activate} from '../activate.service';

@Component({
    selector: 'jhi-activate-email',
    templateUrl: './activate-email.component.html'
})
export class ActivateEmailComponent implements OnInit {
    success: boolean;
    modalRef: NgbModalRef;

    constructor(
        private activate: Activate,
        private router: Router,
        private route: ActivatedRoute
    ) {
    }

    ngOnInit () {
        this.route.queryParams.subscribe(params => {
            this.activate.activateEmail(params['key']).subscribe(() => {
                this.success = true;
            }, () => {
                this.success = false;
            });
        });
    }

    login() {
        this.router.navigate(['authentication']);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/activate/activate-email/activate-email.component.ts